import { z } from 'zod';

/**
 * Loose identification schema for a pre-versioning line: the widget name is the
 * only proof of kind. Everything else is coerced by the migration rather than
 * validated here, so a persisted line with a string width or an unknown border
 * style still lifts to v0 instead of failing to match.
 */
export const lineLegacyShapeSchema = z.looseObject({
    name: z.literal('line'),
});
